var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AbsBox',{staticClass:"bg-canvas"},[(_vm.typeComponent)?_c(_vm.typeComponent,{tag:"component",attrs:{"data":_vm.data,"version":_vm.version}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }